"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableErrorMessage = exports.TableErrorMessageWrapper = exports.TableErrorIconContainer = exports.TableErrorBlock = exports.TableRowsContainer = exports.StyledTable = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledTable = _styledComponents.default.div.withConfig({
  displayName: "Tablestyles__StyledTable",
  componentId: "sc-1iofzr7-0"
})([""]);

exports.StyledTable = StyledTable;

var TableRowsContainer = _styledComponents.default.div.withConfig({
  displayName: "Tablestyles__TableRowsContainer",
  componentId: "sc-1iofzr7-1"
})(["display:flex;flex-direction:column;"]);

exports.TableRowsContainer = TableRowsContainer;

var TableErrorBlock = _styledComponents.default.div.withConfig({
  displayName: "Tablestyles__TableErrorBlock",
  componentId: "sc-1iofzr7-2"
})(["display:flex;flex-direction:row;align-items:center;max-width:100%;width:100%;padding-top:1rem;"]);

exports.TableErrorBlock = TableErrorBlock;

var TableErrorIconContainer = _styledComponents.default.div.withConfig({
  displayName: "Tablestyles__TableErrorIconContainer",
  componentId: "sc-1iofzr7-3"
})(["padding:", ";"], function (props) {
  return props.theme.standardPadding;
});

exports.TableErrorIconContainer = TableErrorIconContainer;

var TableErrorMessageWrapper = _styledComponents.default.div.withConfig({
  displayName: "Tablestyles__TableErrorMessageWrapper",
  componentId: "sc-1iofzr7-4"
})(["flex:1 1 100%;display:flex;flex-direction:column;"]);

exports.TableErrorMessageWrapper = TableErrorMessageWrapper;

var TableErrorMessage = _styledComponents.default.div.withConfig({
  displayName: "Tablestyles__TableErrorMessage",
  componentId: "sc-1iofzr7-5"
})(["padding:", ";color:", ";font-weight:", ";"], function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.c_foreground_danger;
}, function (props) {
  return props.theme.primaryHeavy;
});

exports.TableErrorMessage = TableErrorMessage;